import React from 'react';
import { Link } from 'react-router-dom';
import MoleculeImage from './MoleculeImage';
import './InnCard.css';

const InnCard = ({ compound }) => {
  return (
    <div className="inn-card">
      <Link to={`/inn/${compound.id}`} className="inn-card-link" title="View full record" />
      <div className="inn-card-header">
        <div className="inn-name-block">
          <h3 className="inn-name">{compound.inn_en || compound.latin_name}</h3>
          {compound.description_en && (
            <span className="inn-description">{compound.description_en}</span>
          )}
        </div>
        <span className="inn-list-badge">PL-{compound.list_number}</span>
      </div>

      <div className="inn-card-body">
        {compound.smiles ? (
          <div className="inn-structure">
            <MoleculeImage smiles={compound.smiles} innId={compound.id} width={180} height={140} />
          </div>
        ) : (
          <div className="inn-no-structure">
            <span className="biologic-badge">Biologic</span>
          </div>
        )}

        <div className="inn-meta">
          {compound.cas_number && (
            <div className="inn-meta-row">
              <span className="meta-label">CAS</span>
              <span className="meta-value">{compound.cas_number}</span>
            </div>
          )}
          {'similarity' in compound && (
            <div className="inn-meta-row">
              <span className="meta-label">Similarity</span>
              <span className="meta-value similarity-score">
                {(compound.similarity * 100).toFixed(1)}%
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InnCard;
